import { render, staticRenderFns } from "./B-Chamber-New.vue?vue&type=template&id=481e7a7c&scoped=true&"
import script from "./B-Chamber-New.vue?vue&type=script&lang=js&"
export * from "./B-Chamber-New.vue?vue&type=script&lang=js&"
import style0 from "./B-Chamber-New.vue?vue&type=style&index=0&id=481e7a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e7a7c",
  null
  
)

export default component.exports